import { render, staticRenderFns } from "./SubFamilies.vue?vue&type=template&id=8228e60c"
import script from "./SubFamilies.vue?vue&type=script&lang=js"
export * from "./SubFamilies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports